import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Header from "./components/Header";
import FloatingBanner from "./components/FloatingBanner";
import HeroSection from "./components/HeroSection";
import Download from "./components/download";
import Inquiry from "./components/Inquiry";
import Footer from "./components/Footer";
import PrivacyPolicy from "./components/PrivacyPolicy";
import "./App.css";

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route
          path="/"
          element={
            <div>
              <HeroSection />
              <FloatingBanner />
            </div>
          }
        />

        <Route path="/download" element={<Download />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/inquiry" element={<Inquiry />} />
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
